import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Button,
  Grid,
} from '@material-ui/core';
import EndIcon from '@material-ui/icons/Lens';

import ActivityItem from './ActivityItem';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


const activityList = (props) => {
  let list = null;

  if (props.type !== 'messages') {
    list = props.list.map((item) => {
      const result = (
        <Grid item md={4} sm={4} xs={6} key={item.id}>
          <Link
            target="_blank"
            to={
              formatRoute(
                routes.MANAGE_ACTIVITY_ITEM,
                { slug: item.slug, type: item.activity_type },
              )
            }
            className={classes.linkDeCSS}
          >
            <ActivityItem
              item={item}
            />
          </Link>
        </Grid>
      );
      return result;
    });
  }

  if (props.type === 'messages') {
    list = props.list.map((item) => {
      const result = (
        <Grid item md={12} sm={12} xs={12} key={item.id}>
          <ActivityItem
            item={item}
          />
        </Grid>
      );
      return result;
    });
  }

  let listEnd = null;
  if (!props.next && props.count > 0) {
    listEnd = (
      <div align="center" style={{ marginTop: '20px' }}>
        <EndIcon className={classes.endIcon} />
      </div>
    );
  }

  let nextLoader = null;
  if (props.next) {
    nextLoader = (
      <div align="center" style={{ marginTop: '20px' }}>
        <Button variant="contained" color="primary" onClick={() => props.loadMore(props.next)}>Load More</Button>
      </div>
    );
  }

  return (
    <React.Fragment>
      <Grid container spacing={16}>
        {list}
      </Grid>
      {nextLoader}
      {listEnd}
    </React.Fragment>
  );
};

export default activityList;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityList.js